import Link from 'next/link'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { CONTACT_REQUEST_URL } from '~/core/constants/url'
import { Button } from '~/core/ui/Button'
import LPContainer from './LPContainer'
import Image from 'next/image'

const TalentIntelligenceSectionv2: FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <div className="relative overflow-hidden bg-white min-h-[687px] tablet:min-h-[866px]">
      <div className="z-30 absolute top-16 tablet:top-[70px] inset-x-1/8 w-full flex flex-col justify-center">
        <LPContainer>
          <h1 className="mb-4 animate-fadeInUp text-center leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px]">
            <Trans i18nKey={'allFeature:banner:title'}>
              <p />
              <p />
            </Trans>
          </h1>
          <div className="mx-auto max-w-[343px] font-normal animate-fadeInUp text-center text-1.5xl tablet:max-w-[820px] text-gray-700">
            {t('lp:simple_section:description')}
          </div>
          <Link
            href={CONTACT_REQUEST_URL}
            locale={i18n?.language}
            target="_blank">
            <Button
              size="xl"
              label={`${t('lp:request_demo')}`}
              className="mt-6 mx-auto animate-fadeInUp"
              fontWeight="font-normal"
            />
          </Link>
        </LPContainer>
      </div>

      <div className="relative top-[535px] tablet:top-[394px]">
        <LPContainer>
          <Image
            src="/img/feature/lp/new/talent-intelligence-banner.png"
            width={1218}
            height={0}
            alt="home banner"
          />
        </LPContainer>
      </div>
    </div>
  )
}

export default TalentIntelligenceSectionv2
